import Brain from './Brain'
import './Welcome.css'
const Welcome = () => {
  return (
    <div className='flex sb aic welcome'>
      <div>
        <div>
          <h1>
            Иннов<span className='vector v1'>а</span>ции. <br /> Масштаб. Качество
          </h1>
          <p style={{ maxWidth: 432 }}>Создадим цифровую реальность вашему бизнесу</p>
        </div>
        <a href='#contact-us'>
          <button className='button'>Оставить заявку</button>
        </a>
      </div>
      {/* <img alt='' src='/images/brain-ani.svg' /> */}
      <Brain />
    </div>
  )
}

export default Welcome
